import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, CheckPermission, CModal, ModalFilterUser } from "../../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../../context";
import { DeleteHolidaysApi, HolidaysApi } from "../../../api";
import { getDayOfWeek } from "../../../utils";
import { Link } from 'react-router-dom'

export const Holidays = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [jsonParms, setJsonParms] = useState<any>({})
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [tableData, setTableData] = useState<any>([])
    const col: any = [
        {
            title: "تاریخ",
            render: (i: any) => (
                <div className="flex flex-col">
                    <span className="mt-1">{getDayOfWeek(i.date)}</span>
                    {i.date && i.date != null && new Date(i.date).toLocaleDateString('fa-Ir')}

                </div>
            )
        },
        {
            title: "نوع",
            render: (i: any) => (
                <div className="flex items-center h-[50px]">
                    {i.is_official == 1 &&
                        <>
                            <div className="w-[25px] h-[25px] rounded-full shadow bg-red-400" />
                            <span className=" mr-4">تقویم رسمی</span>
                        </>
                    }
                    {i.is_official == 0 &&
                        <>
                            <div className="w-[25px] h-[25px] rounded-full shadow bg-yellow-300" />
                            <span className=" mr-4">سازمانی</span>
                        </>
                    }
                </div>)
        },
        {
            title: "عنوان ",
            render: (i: any) => (<>{i.title && i.title != null && i.title}</>)
        },
        {
            title: "توضیحات ",
            render: (i: any) => (<>{i.description && i.description != null && i.description}</>)
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex items-center w-full justify-around ">
                    {i.is_official == 0 &&
                        <Link to={`/p/settings/holidays/${i.id}`}>
                            <img src="/assetes/svg/edit.svg" className="w-[20px] cursor-pointer" />
                        </Link>
                    }
                    {CheckPermission(50) &&
                        <img src="/assetes/svg/trash.svg" onClick={() => startDelete(i.id)} className="w-[20px] cursor-pointer" />
                    }
                </div>)
        },

    ]

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteRoll = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteHolidaysApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData(jsonParms)
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }

    const handelSelectYear = (e: any) => {
        let data = { ...jsonParms };
        if (e.target.value != 'all') {
            data['from'] = e.target.value.slice(0, 10);
            data['to'] = e.target.value.slice(11, 21);
        }
        else {
            delete data['from'];
            delete data['to'];
        }
        setJsonParms(data)
        getData(data)
    }

    const getData = async (parms: any) => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await HolidaysApi(parms)
            setTableData(res.data)
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "روز های تعطیل | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 2, })
        getData(jsonParms)

    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">مدیریت روز‌های تعطیل</h1>

            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <div className=" w-full md:w-6/12  flex items-center pl-0 md:pl-2 justify-between">
                    {CheckPermission(48) &&
                        <>
                            <div className=" w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow text-sm">
                                <CSelect placeholder={'ماه'} >
                                    <option value={'all'}>همه</option>
                                    <option value={'1'}>فروردین</option>
                                    <option value={'2'}>اردیبهشت</option>
                                    <option value={'3'}>خرداد</option>
                                    <option value={'4'}>تیر</option>
                                    <option value={'5'}>مرداد</option>
                                    <option value={'6'}>شهریور</option>
                                    <option value={'7'}>مهر</option>
                                    <option value={'8'}>ابان</option>
                                    <option value={'9'}>آذر</option>
                                    <option value={'10'}>دی</option>
                                    <option value={'11'}>بهمن</option>
                                    <option value={'12'}>اسفند</option>
                                </CSelect>
                            </div>
                            <div className=" w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow text-sm">
                                <CSelect placeholder={'سال'} onChange={(e: any) => handelSelectYear(e)} >
                                    <option value={'all'}>سال</option>
                                    <option value={'2022-12-22-2023-01-20'}>1401</option>
                                    <option value={'2023-12-22-2024-01-20'}>1402</option>
                                    <option value={'2024-12-21-2025-01-19'}>1403</option>
                                    <option value={'2025-12-22-2026-01-20'}>1404</option>
                                    <option value={'2026-12-22-2027-01-20'}>1405</option>
                                    <option value={'20275-12-22-2028-01-20'}>1406</option>
                                </CSelect>
                            </div>
                        </>
                    }
                </div>
                <div className=" w-full md:w-[50%] flex justify-end items-center md:mt-0 mt-[7px]">
                    {CheckPermission(49) ?
                        <button className=" w-full md:w-[50%] px-2 h-[40px] bg-dayan-gray-200 rounded-md  text-[11px] text-white overflow-hidden">
                            <Link to='/p/settings/holidays/add' className=" w-full h-full flex justify-center items-center">
                                + اضافه کردن روز تعطیلی سازمانی
                            </Link>
                        </button>
                        :
                        <div />
                    }
                </div>
            </div>

            <div className=" w-full mt-[20px]">
                {CtxLoad.displayLoadingSkelton == false ?
                    <TablePage columns={col} data={tableData} />
                    :
                    <CSkeletonTable />
                }
            </div>

            <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteRoll} loading={CtxLoad.displayLoadingBtn} />

        </div>
    )
}
